import { render, staticRenderFns } from "./StandardReorderable.vue?vue&type=template&id=d299f77e&scoped=true&"
import script from "./StandardReorderable.vue?vue&type=script&lang=ts&"
export * from "./StandardReorderable.vue?vue&type=script&lang=ts&"
import style0 from "./StandardReorderable.vue?vue&type=style&index=0&id=d299f77e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d299f77e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
